
export default {
  BROWSE_FILTER_LOAD: 'BROWSE_FILTER_LOAD',
  BROWSE_FILTER_ERROR: 'BROWSE_FILTER_ERROR',
  BROWSE_FILTER_LOADING: 'BROWSE_FILTER_LOADING',
  BROWSE_FILTER_COURSE: 'BROWSE_FILTER_COURSE',
  BROWSE_FILTER_CUISINE: 'BROWSE_FILTER_CUISINE',
  BROWSE_FILTER_RATING: 'BROWSE_FILTER_RATING'
};


// WEBPACK FOOTER //
// ./modules/browse/constants/FilterConstants.js